import { useBreakpoints, useView } from '@10000/react'
import { useBackground, useShell, useStack } from '../layout'
import { Box, H3 } from '../widgets'
import { AnalyticsData, Compare, useAnalyticsData, YourData } from '.'
import { Toolbar } from '../squiz/common'
import { FreeButtonBar } from '../free'
import './Dashboard.scss'

export const Dashboard = props => (
  <AnalyticsData>
    <DashboardImpl {...props} />
  </AnalyticsData>
)

const DashboardImpl = ({ active }) => {
  const { mode } = useAnalyticsData()
  const { options: { kiosk, free } = {}, stage } = useView('squiz')
  const { pop } = useStack()
  const { mobile } = useBreakpoints()

  useShell(
    (kiosk || free) ? { active, mode: 'logo' }
      : { active, mode: 'authenticated', ...(stage === 'analytics' ? {} : { onLogoClick: pop }) }
  )
  useBackground().set({ active, background: null })

  return (
    <Box column className="dashboard">
      <Box fullWidth justifyContent="space-between" px={32}>
        <H3 align="left" mb={24}>
          Your&nbsp;<br className="mobile-only"/>Analytics
        </H3>

        <Box alignItems="center" gap={24}>
          <Toolbar mobileOnly small />
          {/*<Badges />*/}
          {/*<Box className="desktop-only">*/}
          {/*  <Button rightIcon="Share">Share</Button>*/}
          {/*</Box>*/}
          {/*<Box className="mobile-only">*/}
          {/*  <IconButton icon="Share" size={24} small round />*/}
          {/*</Box>*/}
        </Box>
      </Box>

      {mode === 'compare' ? <Compare /> : <YourData />}

      {mobile &&
        <Box fullWidth p="0 8px 8px 8px">
          <FreeButtonBar />
        </Box>
      }
    </Box>
  )
}